// extracted by mini-css-extract-plugin
export default {"searchboxWrapper":"ChatSearch_searchboxWrapper__qLWvO"};